module.exports = __webpack_public_path__ + "static/media/galerija_2014 (26).2e7c1e27.jpg";